import React from 'react'

import { ErrorMessage } from 'formik'

import { KeySelect } from '../KeySelect'
import { Option } from '@/types/components'

/**
 * @deprecated key-* components are no longer supported.
 */
export const KeySelectField = (props) => {
  const value = props.value
    ? props.value
    : props.options
      ? props.options.find((option) => option.value === props.field.value)
      : null
  return (
    <div>
      <KeySelect
        options={props.options}
        name={props.field.name}
        value={value ?? ''}
        onChange={(option: Option) => {
          props.form.setFieldValue(props.field.name, option.value)
          if (props.onChange) props.onChange(option.value)
        }}
        onBlur={props.onBlur}
        className={props.className}
        placeholder={props.placeholder}
        inputId={props.inputId}
        styles={props.styles}
        isDisabled={props.disabled}
      />
      <ErrorMessage name={props.field.name}>
        {(msg) => <p className='text-error'>{msg}</p>}
      </ErrorMessage>
    </div>
  )
}
